import {ALL_HIGHLIGHT_NAMES} from './annotationConstants';
import {isHighlightApiSupported} from './annotationUtils';

/**
 * Sole owner of `CSS.highlights`. The names are document-global, so every
 * write merges all regions' ranges; per region, last write wins.
 */
const rangesByRegionId = new Map<string, ReadonlyMap<string, Range[]>>();

function rebuildHighlights(): void {
  if (!isHighlightApiSupported()) {
    return;
  }
  ALL_HIGHLIGHT_NAMES.forEach((name) => {
    const merged: Range[] = [];
    rangesByRegionId.forEach((regionRanges) => {
      merged.push(...(regionRanges.get(name) ?? []));
    });
    if (merged.length === 0) {
      CSS.highlights.delete(name);
    } else {
      CSS.highlights.set(name, new Highlight(...merged));
    }
  });
}

/** Replaces `regionId`'s painted ranges; a map with no ranges clears the region. */
export function setRegionHighlights(
  regionId: string,
  rangesByName: ReadonlyMap<string, Range[]>
): void {
  if (rangesByName.size === 0) {
    clearRegionHighlights(regionId);
    return;
  }
  rangesByRegionId.set(regionId, rangesByName);
  rebuildHighlights();
}

/** True while `regionId` has painted ranges registered. */
export function hasRegionHighlights(regionId: string): boolean {
  return rangesByRegionId.has(regionId);
}

export function clearRegionHighlights(regionId: string): void {
  // Observers clear on every mutation batch; only the first has anything to erase.
  if (!rangesByRegionId.delete(regionId)) {
    return;
  }
  rebuildHighlights();
}

export function resetPaintCoordinator(): void {
  rangesByRegionId.clear();
  rebuildHighlights();
}
